import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as a } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as j, useRef as v } from "react";
import s from "./Checkbox.module.scss.js";
import C from "../Icon/Icon.js";
import { Typography as m } from "../Typography/Typography.js";
const N = ({
  id: f,
  className: i = "",
  active: o = !1,
  indeterminate: u = !1,
  disabled: c = !1,
  label: r = "",
  testId: h,
  labelTestId: p,
  description: t = "",
  direction: d = "left",
  onChange: k,
  ...g
}) => {
  const x = v(null), l = () => /* @__PURE__ */ e.jsxs("div", { className: s.inputContainer, children: [
    /* @__PURE__ */ e.jsx(
      "input",
      {
        id: f,
        type: "checkbox",
        ref: x,
        className: a(s.checkbox, i, {
          [s.active]: o,
          [s.disabled]: c
        }),
        onChange: k,
        disabled: c,
        "data-testid": h,
        checked: o,
        ...g
      }
    ),
    o && /* @__PURE__ */ e.jsx("div", { className: s.checkIconContainer, children: /* @__PURE__ */ e.jsx(
      C,
      {
        name: u ? "minus" : "check",
        size: "xxxs",
        className: "text-color-fg-inverse"
      }
    ) })
  ] });
  return !r && !t ? l() : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: a(
        "flex items-start gap-100 w-full",
        d === "right" && `flex-row-reverse ${t && r ? "items-start" : "items-center"}`
      ),
      children: [
        l(),
        (r || t) && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-050 flex-grow", children: [
          r && /* @__PURE__ */ e.jsx(
            m,
            {
              text: r,
              testId: p,
              onClick: () => {
                var n;
                return (n = x.current) == null ? void 0 : n.click();
              },
              variant: "interface/medium/sm",
              textColor: "color/fg/default",
              className: a("py-[2.5px] cursor-pointer w-fit", c && "cursor-not-allowed")
            }
          ),
          t && /* @__PURE__ */ e.jsx(
            m,
            {
              text: t,
              variant: "body-new/regular",
              textColor: "color/fg/lighter"
            }
          )
        ] })
      ]
    }
  );
}, z = j(N);
export {
  z as default
};
//# sourceMappingURL=Checkbox.js.map
